export const fetchToken = ({clientId, clientSecret, code, state, tokenEndpoint, fetch = window.fetch}) => {
    const payload = {
        client_id: clientId,
        //client_secret: clientSecret,
        code,
        grant_type: 'authorization_code',
        code_verifier: state.encodedVerifier,
        redirect_uri: state.redirectUri,
        challenge_method: 's256'
    };

    return fetch(tokenEndpoint, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: new window.URLSearchParams(payload)
    })
        .then(r => {
            if (!r.ok) {
                throw new Error(`Failed to retrieve token.`);
            }
            return r.json();
        })
        .then(token => {
            const {expires_in} = token;
            if (expires_in && Number.isFinite(expires_in)) {
                const slackSeconds = 10;
                token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
            }
            return token;
        })
        .catch(err => {
            console.error('ERR (fetch)', err);
            throw err;
        });
}
